module.exports = __webpack_public_path__ + "img/Access Storage Logo.4fad43de.png";